import { OrderSummaryCard } from '@components/cards/order/summary';
import { TBookingAsset, TOrder } from '@components/types';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import React from 'react';

interface Props {
  orders: (TOrder | TBookingAsset)[];
  title?: string;
  element?: React.ElementType;
  setOrderStage?: Function
  setDetailOrder?: Function
  noLink?: boolean
  maxWidth?: string
  reloadFunction?: Function
  actionFunction?: Function
  pageNumber?: number
  pageSize?: number
  setPageNumber?: Function
  onCardClick?: (order: TBookingAsset) => void
  // Passed straight through to booking cards so they can offer "Delete Draft"; ignored by
  // card types that don't take them.
  userId?: number
  onDeleteDraft?: (order: TBookingAsset) => void
  deletingOrderId?: number
  onPayDue?: (order: TBookingAsset) => void
  payingOrderId?: number
}

export const OrderSummaryContainer = ({ orders, element, title, setOrderStage, setDetailOrder, noLink = false, maxWidth, reloadFunction, actionFunction, pageNumber, pageSize, setPageNumber, onCardClick, userId, onDeleteDraft, deletingOrderId, onPayDue, payingOrderId }: Props) => {
  let RepeatElement =
    element == undefined || element == null ? OrderSummaryCard : element;
  return (
    <div className="flex w-full flex-col gap-1 rounded-t-xl">
      {title && (
        <div className="px-2 w-full bg-neutral-800 text-neutral-50 font-semibold text-lg rounded-t-xl">
          {title}
        </div>
      )}
      <div className={`grid w-full ${maxWidth?.length > 0 ? "grid-cols-1" : "grid-cols-2"} lt-sm:grid-cols-1 gap-4`}>
        {orders &&
          (orders as TOrder[])?.map((order: TOrder) => (
            <RepeatElement noLink={noLink} order={order} key={order?.id} setOrderStage={setOrderStage}
              setDetailOrder={setDetailOrder} reloadFunction={reloadFunction ? reloadFunction : null} webCheckinFunc={actionFunction ? actionFunction : null} onCardClick={onCardClick}
              userId={userId} onDeleteDraft={onDeleteDraft} deleting={!!deletingOrderId && String(order?.id) === String(deletingOrderId)}
              onPayDue={onPayDue} paying={!!payingOrderId && String(order?.id) === String(payingOrderId)} ></RepeatElement>
          ))}
      </div>
      {(orders?.length > 0 || pageNumber > 1) && setPageNumber && <div className="flex items-center gap-2 py-2 justify-center">
        <button disabled={pageNumber === 1} onClick={() => setPageNumber?.(pageNumber - 1)} className={`${pageNumber === 1 ? "opacity-50 cursor-not-allowed" : "bg-white cursor-pointer"} text-neutral-700 flex gap-2 items-center active:bg-white font-bold uppercase text-sm px-4 py-2 rounded border border-neutral-300 border-solid`}><ChevronLeft /> Previous</button>
        <div>{pageNumber}</div>
        <button disabled={orders?.length < pageSize} className={`${orders?.length < pageSize ? "opacity-50 cursor-not-allowed" : "bg-white cursor-pointer"} text-neutral-700 flex gap-2 items-center active:bg-white font-bold uppercase text-sm px-4 py-2 rounded border border-neutral-300 border-solid`} onClick={() => setPageNumber?.(pageNumber + 1)}>Next <ChevronRight /></button>
      </div>}
    </div>
  );
};
